define('modules/econ/controllers/EconNewsletterController',[
    'modules/module',
    'modules/basemodule/controllers/EntityListController'
	], 
	function (module) {
        'use strict';
		module.controller('EconNewsletterController', [
			'$scope',
			'$controller',
            EconNewsletterController
        ]);
    }
);

function EconNewsletterController($scope, $controller) {

    angular.extend(this, $controller('EntityListController', {
        $scope: $scope
    }));

    $scope.formState = 'root.econNewsletter';

    $scope.tableOptions.fields = [
        {
            id: 'NAME',
            heading: 'Name',
            attribute: 'name'
        },
        {
            id: 'SENDER',
            heading: 'Absender',
            attribute: 'sender'
        },
        {
            id: 'SUBJECT',
            heading: 'Betreff',
            attribute: 'subject'
        }
    ];

    $scope.init('Newsletter');
   
};
